<template>
  <report-layout :available-reports="$parent.availableReports" :openedReport="$parent.openedReport" close-path="/team/reports">
    <template v-slot:header>
      <div v-if="!$parent.loading">
        <h1 class="info-headline">{{$t('common:title-vigor')}}</h1>
        <h5><span>{{ $t('common:description-organization-vigor') }}</span></h5>
      </div>
    </template>
    <div v-if="!$parent.loading && $parent.currentEngagementReport.stats">
      <b-row align-v="center" align-h="center" class="mt-2">
        <b-col cols="12" sm="12" md="5" order-md="2">
          <b-row>
            <b-col>
              <div class="overall-score">
                <span class="--value">{{$parent.formatNumber0($parent.currentEngagementReport.stats['uwes9-vigor']/6.0*100)}}</span>
                <span class="--scale">/ 100</span>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div class="animated-bar">
                <div class="meter" :class="{'activated': $parent.teamUWESPercent !== 0}" :style="{'background-color': $parent.mapColor($parent.currentEngagementReport.categories['uwes9-vigor']), 'width': $parent.teamVigorPercent}"></div>
              </div>
              <p class="tidbit">{{$t('common:updated')}} {{$parent.currentEngagementReport.updatedAt | moment('from')}}.</p>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" md="5" order-md="1">
          <h3 class="feedback-title">
            <span v-html="$t('work-engagement-snapshot:vigor-score', { vigorClassification: '$t(classification-'+$parent.currentEngagementReport.categories['uwes9-vigor']+')', vigorScore: $parent.formatNumber0($parent.currentEngagementReport.vigor.avg/6.0*100) })"></span>
            <!-- <span v-html="$t('work-engagement-snapshot:work-engagement-score', { workEngagementClassification: '$t(classification-'+$parent.currentEngagementReport.categories['uwes9-vigor']+')', workEngagementScore: $parent.formatNumber0($parent.currentEngagementReport.stats['uwes9-vigor'].avg/6.0*100) })"></span> -->
            <!-- <span>{{ $t('personal-results:total-classification-title-' + $parent.currentEngagementReport.categories['uwes9-vigor']) }}</span> -->
          </h3>
        </b-col>
      </b-row>

      <b-row align-v="center" align-h="center" class="mt-2">
        <b-col cols="12" sm="12" md="5" order-md="2">
          <barchart :items="$parent.vigorItems"/>
        </b-col>
        <b-col cols="12" md="5" order-md="1">
          <h3 class="feedback-title mt-3">
            <span v-if="$parent.currentEngagementReport.vigor.max - $parent.currentEngagementReport.vigor.min >= 4">
              {{$t('work-engagement-snapshot:assessment-vigor-range-4')}}
            </span>
            <span v-else-if="$parent.currentEngagementReport.vigor.max - $parent.currentEngagementReport.vigor.min >= 3">
              {{$t('work-engagement-snapshot:assessment-vigor-range-3')}}
            </span>
            <span v-else-if="$parent.currentEngagementReport.vigor.max - $parent.currentEngagementReport.vigor.min >= 2">
              {{$t('work-engagement-snapshot:assessment-vigor-range-2')}}
            </span>
            <span v-else-if="$parent.currentEngagementReport.vigor.max - $parent.currentEngagementReport.vigor.min >= 1">
              {{$t('work-engagement-snapshot:assessment-vigor-range-1')}}
            </span>
            <span v-else-if="$parent.currentEngagementReport.vigor.max - $parent.currentEngagementReport.vigor.min > 0.5">
              {{$t('work-engagement-snapshot:assessment-vigor-range-0_5')}}
            </span>
            <span v-else>
              {{$t('work-engagement-snapshot:assessment-vigor-range-no')}}
            </span>
            <span v-html="$t('work-engagement-snapshot:assessment-vigor-range', { lowClassification: '$t(classification-'+$parent.currentEngagementReport.categories['uwes9-vigor-min']+')', lowScore: $parent.formatNumber0($parent.currentEngagementReport.vigor.min/6.0*100), highClassification: '$t(classification-'+$parent.currentEngagementReport.categories['uwes9-vigor-max']+')', highScore: $parent.formatNumber0($parent.currentEngagementReport.vigor.max/6.0*100) })"></span>
          </h3>
        </b-col>
      </b-row>
    </div>
  </report-layout>
</template>
<script>
import BarChart from '../../common/barchart/BarChart'
import ReportLayout from '../../layouts/ReportLayout'
export default {
  components: {
    barchart: BarChart,
    ReportLayout
  },
  mounted: function () {
    this.$parent.openedReport = 'vigor'
  }
}
</script>
